export default [
  {
    // 工单列表
    path: "serviceOrder/index",
    name: "ServiceOrderIndex",
    component: () => import("../pages/serviceOrder/Index"),
    meta: {
      title: "工单列表",
    },
  },
  {
    // 创建工单
    path: "serviceOrder/Create/:rec_id",
    name: "ServiceOrderCreate",
    component: () => import("../pages/serviceOrder/Create"),
    meta: {
      title: "创建工单",
    },
  },

  {
    // 用户申请列表
    path: "serviceOrder/applicantList",
    name: "ServiceOrderApplicantList",
    component: () => import("../pages/serviceOrder/ApplicantList"),
    meta: {
      title: "用户申请列表",
    },
  },

  {
    // 换货补发工单列表
    path: "serviceOrder/returnAndReissueList",
    name: "ReturnAndReissueList",
    component: () => import("../pages/serviceOrder/returnAndReissueList"),
    meta: {
      title: "换货补发工单列表",
    },
  },

  {
    // 带审核列表
    path: "serviceOrder/waitCheckList",
    name: "ServiceOrderWaitCheckList",
    component: () => import("../pages/serviceOrder/WaitCheckServiceOrderList"),
    meta: {
      title: "待审核列表",
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/serviceOrder.js